/**
 * Fix Chrome bug
 * Chrome ≈105 tries to load .mov files and fails, but doesn't load .webm instead, because
 * gutenberg doesn't add the "type" attribute :-( so we add it manually
 * @see https://stackoverflow.com/questions/73887999/chrome-tries-to-load-video-formats-it-does-not-support-failing-to-load-those-it
 */
export const fixChromeBug = () => {
	document.querySelectorAll('video source[src$="mov"]')?.forEach((mov) => {
		mov.setAttribute('type', 'video/quicktime')
		mov.parentElement.load()
	})
}
